import { Checkbox, Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import { useSessionStore } from 'session/useSessionStore';
import { useGet3DProjectionConfigList } from '../api/useProjections3DConfigController';
import { Viewer3DStrategy } from '../models/enums/Viewer3DStrategy';
import { Projections3DListRow } from './Projection3DListRow';

export const Projections3DList = () => {
    const viewer3DStrategy = useSessionStore(state => state.tenantConfiguration?.viewer3DStrategy);

    const { data: projectionConfigList } = useGet3DProjectionConfigList(viewer3DStrategy === Viewer3DStrategy.GeomBased);

    return (
        <Stack>
            <Table>
                <TableHead>
                    <TableCell size='small'>
                        Select
                    </TableCell>
                    <TableCell size='small'>
                        Title
                    </TableCell>
                </TableHead>
                <TableBody>
                    {
                        projectionConfigList?.map(projectionConfig =>
                            <Projections3DListRow projectionConfig={projectionConfig}/>
                        )
                    }
                </TableBody>
            </Table>
        </Stack>
    );
};